
import * as yup from "yup";

export const ValidationSchema = yup.object().shape({
    Company: yup.string(),
    Firstname: yup.string().required('Voornaam is vereist'),
    Insertion: yup.string(),
    Surname: yup.string().required('Achternaam is vereist'),
    Email: yup.string().email().required('Email is vereist'),
    Phonenumber: yup.string().required('Telefoonnummer is vereist')
});
